const KEY = "gl_ref";
const WINDOW_MS = 30 * 24 * 3600 * 1000;

export function captureRef(code) {
  if (!code) return;
  const c = String(code).trim().toUpperCase().slice(0, 20);
  if (/^[A-Z0-9]{4,20}$/.test(c)) localStorage.setItem(KEY, JSON.stringify({ code: c, at: Date.now() }));
}

export function getRef() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!v || Date.now() - v.at > WINDOW_MS) { localStorage.removeItem(KEY); return ""; }
    return v.code;
  } catch { return ""; }
}
